import { canShowPremiumFeatures } from 'utils/core';

export const getAirmeetDetails = ({
    formData,
    subscription_type,
    mode,
    getTzAdjustedPayload,
    pageMode,
    onboardingInitiation,
    endDateToStartDateTimeDiff,
}) => {
    const premiumFeaturesVisible = canShowPremiumFeatures(
        subscription_type,
        mode === 'Conference' &&
            subscription_type !== 'ENTERPRISE' &&
            subscription_type !== 'APPSUMO'
    );

    const metadata = {
        name: formData.name,
        shortDesc: formData.description,
        private: formData.isPrivate,
        noauth: formData.noAuth,
        attendeeListEnabled: formData.isAttendeeList,
    };
    const miscInfo = {
        enableRtmpKey: premiumFeaturesVisible,
        eventImage: formData.eventImage,
        longDesc: formData.longDesc,
        networking: formData.hasVirtualTables,
        tableCount:
            (formData.hasVirtualTables && +formData.tableCount) || undefined,
    };
    const adjustedTime = getTzAdjustedPayload(formData, true);
    const timeInfo = {
        startTime: adjustedTime.initDate.getTime(),
        endTime:
            pageMode && onboardingInitiation
                ? adjustedTime.initDate.getTime() + endDateToStartDateTimeDiff
                : adjustedTime.finalDate.getTime(),
        tz: adjustedTime.timeZone,
    };
    return {
        metadata,
        miscInfo,
        timeInfo,
    };
};
